var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-checkbox-text",class:{ invalid: _vm.invalid && _vm.invalid.length !== 0 }},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":_vm.handleInput}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }